module.exports = __webpack_public_path__ + "img/come.df6cc2ee.png";